import { render, staticRenderFns } from "./tutorList.vue?vue&type=template&id=0ddace84"
import script from "./tutorList.vue?vue&type=script&lang=js"
export * from "./tutorList.vue?vue&type=script&lang=js"
import style0 from "./tutorList.vue?vue&type=style&index=0&id=0ddace84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports